/**
 * First we will load all of this project's JavaScript dependencies which
 * include Vue and Vue Resource. This gives a great starting point for
 * building robust, powerful web applications using Vue and Laravel.
 */
require('./bootstrap');

require('smoothscroll-polyfill').polyfill()
require('./includes/navigation')
require('./includes/fiche-droits')
require('bootstrap.native')
require('./includes/donations')

if (document.body.classList.contains('home')) {
  require('./includes/home')
}

if (document.body.classList.contains('single-publication')) {
  require('./includes/publication')
}

if (
  document.body.classList.contains('page-template-decrypter') ||
  document.body.classList.contains('tax-thematique')
) {
  require('./includes/themathiques')
}

if (document.body.classList.contains('page-template-connaitre-et-faire-respecter-ses-droits')) {
  require('./includes/c-et-fr-droits')
}

if (document.body.classList.contains('page-template-contact')) {
  require('./includes/contact')
}

if (document.body.classList.contains('page-template-default') && document.body.classList.contains('page-id-309')) {
  require('./includes/contact')
  require('./includes/temoigner')
}

if (document.body.classList.contains('page-template-etablissements')) {
  require('js-marker-clusterer')
}

/**
 * Vue app
 */

let pagination = require('vuejs-uib-pagination')
let VuePaginate = require('vue-paginate')
Vue.use(VuePaginate)
Vue.use(pagination)
Vue.component('etablissement-page', require('./components/etablissements/EtablissementPage.vue'));
Vue.component('publication-list', require('./components/publications/PublicationList.vue'));
Vue.component('post-list', require('./components/posts/PostList.vue'));
Vue.component('agenda-list', require('./components/agenda/AgendaList.vue'));
//Vue.component('en-savoir-plus', require('./components/EnSavoirPlus.vue'));

if (
  document.body.classList.contains('page-template-publications-dedans-dehors')
  || document.body.classList.contains('page-template-publications-ouvrages')
  || document.body.classList.contains('page-template-liste-darticles')
  || document.body.classList.contains('page-template-liste-infographies')
  || document.body.classList.contains('search')
  || document.body.classList.contains('tax-thematique')
  || document.body.classList.contains('post-type-archive-agenda')
) {
  const app = new Vue({
    el: '#app',
      pagination: {}
  });
}

if (document.body.classList.contains('single-etablissement')) {
  require('./includes/en-savoir-plus')
}

//if (document.body.classList.contains('single-publication')) {
  require('./includes/en-savoir-plus')
//}

if (document.body.classList.contains('page-template-etablissements')) {

  var eventHub = new Vue()

  window.eventHub = eventHub

  window.app = new Vue({
    el: '#app',

    data () {
      return {
        map: null,
        google: null
      }
    },

    methods: {

      init () {
        eventHub.$emit('mapsApiLoaded')
      },

      createMap () {
        this.map = new google.maps.Map(document.getElementById('map'), {
          zoom: 6,
          streetViewControl: false,
          mapTypeControl: false,
          scrollwheel: false,
          zoomControlOptions: {
            position: google.maps.ControlPosition.LEFT_BOTTOM
          },
          center: {
            lat: 46.589,
            lng: 2.449
          },
          styles: [{
            "featureType": "landscape.natural",
            "elementType": "geometry.fill",
            "stylers": [{ "visibility": "on" }, { "color": "#f9f9f9" }]
          }, {
            "featureType": "poi",
            "elementType": "geometry.fill",
            "stylers": [{ "visibility": "on" }, { "color": "#c1ede2" }]
          }, {
            "featureType": "road",
            "elementType": "geometry",
            "stylers": [{ "lightness": 100 }, { "visibility": "simplified" }]
          }, {
            "featureType": "road",
            "elementType": "labels",
            "stylers": [{ "visibility": "off" }]
          }, {
            "featureType": "transit.line",
            "elementType": "geometry",
            "stylers": [{ "visibility": "on" }, { "lightness": 700 }]
          }, {
            "featureType": "water",
            "elementType": "all",
            "stylers": [{ "color": "#bae9f9" }]
          }]
        })
      },

    },

    mounted () {
      eventHub.$on('mapsApiLoaded', this.createMap)
    }
  });
}



// WEBPACK FOOTER //
// ./resources/assets/js/app.js